module.exports = __webpack_public_path__ + "static/media/Cardano.22a12458.png";